import { profileActions } from "../../../di/di";
import { useDispatch, useSelector } from "react-redux";
import { reactivateTier } from "../state/profile_slice";

export default function ReactivateSubscriptionModalComponent() {
  const dispatch = useDispatch();

  const reactivatePlanModalOpen = useSelector((state) => state.profile.reactivatePlanModalOpen);
  const isReactivatingTier = useSelector((state) => state.profile.isReactivatingTier);

  const onHandleConfirm = () => {
    dispatch(reactivateTier());
  };

  if (!reactivatePlanModalOpen) {
    return null;
  }

  return (
    <div className="fixed lg:ml-[15rem] inset-0 flex items-center justify-center bg-black bg-opacity-70">
      <div className="bg-gradient-to-b from-slate-950/90 to-fuchsia-950/70 backdrop-blur-md border border-red-900/20 rounded-xl p-6 w-full max-w-md mx-4 animate-fade-in-up">
        <h3 className="text-xl font-bold text-white mb-4">Confirm Reactivation</h3>
        <div className="mb-6">
          <p className="text-pink-300 mb-4 text-base">Do you want to reactivate your subscription?</p>
        </div>
        <div className="flex justify-end space-x-3">
          <button
            onClick={() => dispatch(profileActions.setReactivatePlanModalOpen(false))}
            className="text-base px-4 py-2 text-white bg-slate-900/70 rounded-full hover:bg-slate-800/80 border border-red-900/20 transition-all active:translate-y-0.5 active:shadow-none"
          >
            Cancel
          </button>
          <button
            onClick={() => onHandleConfirm()}
            className="text-base px-4 py-2 text-white bg-red-600 rounded-full hover:bg-red-700 transition-all active:translate-y-0.5 active:shadow-none flex items-center justify-center gap-2"
            disabled={isReactivatingTier}
          >
            {isReactivatingTier ? (
              <>
                <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                Reactivating...
              </>
            ) : (
              "Reactivate Subscription"
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
